'use client';

import type { FC, ReactNode } from 'react';
import { createContext, useContext, useState, useEffect } from 'react';
import { usePathname } from 'next/navigation';

interface HeaderContextType {
  title: string;
  setTitle: (title: string) => void;
}

const HeaderContext = createContext<HeaderContextType | undefined>(undefined);

export const HeaderProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [title, setTitle] = useState('');
  const pathname = usePathname();

  useEffect(() => {
    switch (pathname) {
      case '/dashboard':
        setTitle('Dashboard');
        break;
      case '/design-system':
        setTitle('Bloom Design System');
        break;
      default:
        setTitle('Daten & Einblicke');
    }
  }, [pathname]);

  return <HeaderContext.Provider value={{ title, setTitle }}>{children}</HeaderContext.Provider>;
};

export const useHeader = () => {
  const context = useContext(HeaderContext);
  if (!context) {
    throw new Error('useHeader must be used within a HeaderProvider');
  }
  return context;
};
